import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import get from 'lodash/get';

import { SuiFile, withLabel, withHelperText } from '@splashthat/sui';

import { ERROR_UPLOADING_INVALID_TYPE } from 'common/entities/form/errorMessages';
import { ERROR_UPLOADING } from '../../../constants/errorTypes';
import { getUploadUrl } from '../../../selectors';
import { getFormErrors } from '../../../selectors/form';
import { setFormErrors, setFieldError } from '../../../actions/form';
import { reportGAFormError } from '../../../epics/form';

const FILE_FIELD_NUMBER = 'X';
const FILE_FIELD_NAME = `custom_field_${FILE_FIELD_NUMBER}`;

const ERROR_CODE_TO_MESSAGE = {
    invalidFileType: ERROR_UPLOADING_INVALID_TYPE,
    default: ERROR_UPLOADING,
};

const HelperTextSuiFile = withHelperText(SuiFile);
const LabeledSuiFile = withLabel(HelperTextSuiFile);

const generateFormData = (file) => {
    const formData = new FormData();

    formData.append(FILE_FIELD_NAME, file);
    formData.append('action', 'upload-custom-rsvp-file');

    return formData;
};
const uploadFile = (url, formData) =>
    axios({
        url,
        method: 'POST',
        data: formData,
        withCredentials: true,
    }).then(({ data }) => data[FILE_FIELD_NUMBER].path);

class SuiFileWrapper extends React.Component {
    static propTypes = {
        'aria-required': PropTypes.bool,
        name: PropTypes.string.isRequired,
        url: PropTypes.string,
        onDrop: PropTypes.func,
        onRemove: PropTypes.func,
        setFieldValue: PropTypes.func.isRequired,
        setFieldError: PropTypes.func.isRequired,
        reportGAFormError: PropTypes.func.isRequired,
        setFormErrors: PropTypes.func.isRequired,
        errors: PropTypes.object.isRequired,
    };

    static defaultProps = {
        url: null,
        onDrop: () => {},
        onRemove: () => {},
        eventId: null,
    };

    state = {
        loading: false,
        error: false,
    };

    onRemove = (...args) => {
        this.props.setFieldValue(this.props.name, null);

        if (this.props.onRemove) {
            this.props.onRemove(...args);
        }
    };

    onDrop = (file) => {
        const formData = generateFormData(file);

        if (this.props.onDrop) {
            this.props.onDrop(file);
        }

        if (this.props.url) {
            this.setState({
                loading: true,
                error: false,
            });
            this.props.setFormErrors({
                ...this.props.errors,
                [this.props.name]: undefined,
            });

            uploadFile(this.props.url, formData)
                .then((fileUrl) => {
                    this.setState({ loading: false, error: false });
                    this.props.setFieldValue(this.props.name, fileUrl);
                })
                .catch((error) => {
                    const code = get(error, 'response.data.error.code');
                    const errorMsg = ERROR_CODE_TO_MESSAGE[code] || ERROR_CODE_TO_MESSAGE.default;

                    this.props.setFieldError(this.props.name, [errorMsg]);
                    this.props.reportGAFormError();
                    this.setState({
                        loading: false,
                        error: true,
                    });
                });
        }
    };

    render() {
        return (
            <LabeledSuiFile
                {...this.props}
                variation={this.state.error ? 'error' : ''}
                error={this.state.error}
                loading={this.state.loading}
                onDrop={this.onDrop}
                onRemove={this.onRemove}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    ...state,
    url: getUploadUrl(state),
    errors: getFormErrors(state),
});

const mapDispatchToProps = {
    setFormErrors,
    setFieldError,
    reportGAFormError,
};

export { SuiFileWrapper as UnconnectedSuiFileWrapper };

export default connect(mapStateToProps, mapDispatchToProps)(SuiFileWrapper);
